import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { NumberNull, StringNumber, Tarefa } from "../../../../../types";

export const SelectPresenca = (
  { idevento, idsubtarefa, action, valor: _val }:
  { idevento: number, idsubtarefa: NumberNull, action: any, valor?: StringNumber | null }) => {

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Presença</FormLabel>
        {
          idevento && idsubtarefa && (
            <Select
              value={_val}
              onChange={action}
            >
              {
                [
                  {
                    descricao: 'Não Presente',
                    value: false
                  },
                  {
                    descricao: 'Presente',
                    value: true
                  },
                  {
                    descricao: 'N/A',
                    value: ''
                  },
                ]?.map(
                  value =>
                    <MenuItem value={`${value?.value}`}>
                      {value?.descricao}
                    </MenuItem>
                )
              }
            </Select>
          )
        }
      </Grid>
    </>
  )
}
